export const setEvaluation = payload => (dispatch, getState) => {
  dispatch({ type: "SET_EVALUATION", payload });
};
